import type { State } from './typings'

export const initialState: State = {
  content: 'list',
  contentOpened: false,
  current: undefined,
  filtersChecksum: undefined,
  popoverEl: null,
  activities: [],
  activityTypes: [],
  filters: {
    closingActivities: {
      filters: [],
      name: 'Closing Activities',
    },
    customActivities: {
      filters: [],
      name: 'Custom Activities',
    },
    statusUpdates: {
      filters: [],
      name: 'Status Updates',
    },
  },
  history: [],
}
